module.exports = __webpack_public_path__ + "img/suitcase.e4c5a0be.svg";